// Module
var code = "<template> <pre textcontent.bind=\"content\"></pre> </template> ";
// Exports
export default code;